import React, { useEffect, useRef, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { UserRound, ChevronDown, LogOut } from "lucide-react";
import { logOut } from "../../components/Logout";
import "./SupervisionLayout.css";
import { getAuthToken, handleGetLocal } from "../../services/auth-service";
import httpService from "../../services/http-service";

export default function SupervisionLayout() {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [displayName, setDisplayName] = useState("");

  useEffect(() => {
    let cancelled = false;

    const loadUserName = async () => {
      const username = localStorage.getItem("username");
      const token = getAuthToken("token");
      const domain = handleGetLocal("pathURL");

      if (!username || !token || !domain) return;

      try {
        const response = await httpService.get("/api/Account/getUserInfoDetail", {
          params: { username },
          headers: {
            Authorization: `Bearer ${token}`,
            Domain: domain,
          },
        });

        if (cancelled) return;

        const user = response.data?.data;

        const name = [user?.sFirstName, user?.sLastName].filter(Boolean).join(" ").trim();

        setDisplayName(name || username);
      } catch (error) {
        if (!cancelled) {
          setDisplayName(username);
        }
      }
    };

    loadUserName();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="supervision-portal">
      <header className="supervision-header">
        <div className="supervision-brand">
          <h2>SCRAM Drug Testing</h2>
          <span>Supervision Portal</span>
        </div>

        {/* User profile and Logout dropdown */}
        <div className="sp-header-user" ref={menuRef}>
          <button
            type="button"
            className="sp-header-user-btn"
            onClick={() => setUserMenuOpen((prev) => !prev)}
            aria-label="User menu"
            aria-expanded={userMenuOpen}
          >
            <UserRound size={23} />

            <span className="sp-header-username">{displayName || "User"}</span>

            <ChevronDown size={15} />
          </button>

          {userMenuOpen && (
            <div className="sp-header-user-dropdown">
              <button type="button" className="sp-header-logout" onClick={logOut}>
                <LogOut size={18} />
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      <nav className="supervision-nav">
        <NavLink to="/supervision/participants">Participants</NavLink>
        <NavLink to="/supervision/test-results">Test Results</NavLink>
        <NavLink to="/supervision/scheduling">Scheduling</NavLink>
      </nav>

      <main className="supervision-main">
        <Outlet />
      </main>
    </div>
  );
}
